module.exports = __webpack_public_path__ + "img/pr-7.6fb921e3.png";